module.exports = __webpack_public_path__ + "img/audit@2x.90ddf5b1.png";